export default __webpack_public_path__ + "atomic/_patterns/02-molecules/sales-manager/_sales-manager.twig";